import React, { useState } from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Chip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formFieldStyles } from './FormField.styles';

const CustomSelectField = ({
  field,
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
  formData = {},
}) => {
  const { t } = useTranslation();
  const [isCustom, setIsCustom] = useState(false);
  const [customValue, setCustomValue] = useState('');

  const handleChange = (event) => {
    const newValue = event.target.value;
    
    if (newValue === field.customValue) {
      setIsCustom(true);
      setCustomValue(value || '');
      if (onChange) {
        onChange(field.name, value || '', event);
      }
    } else {
      setIsCustom(false);
      if (onChange) {
        onChange(field.name, newValue, event);
      }
    }
  };

  const handleCustomChange = (event) => {
    const newValue = event.target.value;
    setCustomValue(newValue);
    if (onChange) {
      onChange(field.name, newValue, event);
    }
  };

  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(field.name, value, event);
    }
  };

  const baseProps = {
    disabled: field.disabled || disabled,
    error: !!error,
    fullWidth: true,
    sx: formFieldStyles.field,
  };

  if (isCustom) {
    return (
      <Box>
        <FormControl {...baseProps}>
          <InputLabel>{field.label ? t(field.label) : ''}</InputLabel>
          <Select
            value={field.customValue}
            label={field.label ? t(field.label) : ''}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            {field.options?.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          {...baseProps}
          label={field.customLabel}
          value={customValue}
          onChange={handleCustomChange}
          onBlur={handleBlur}
          placeholder={field.placeholder ? t(field.placeholder) : ''}
          sx={{ mt: 1 }}
        />
      </Box>
    );
  }

  return (
    <FormControl {...baseProps}>
      <InputLabel>{field.label ? t(field.label) : ''}</InputLabel>
      <Select
        value={value || ''}
        label={field.label ? t(field.label) : ''}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={field.placeholder || ''}
      >
        {field.options?.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default CustomSelectField; 